import { STATE_PER_METRO } from '../../../common/components/SearchHeader/constants';
import { FilterChoice } from '../../../common/components/SearchHeader/types/FilterChoice';
import { safeKeysOf } from '../../../common/util/safeKeysOf';
import { SuburbLinks } from './SuburbLinks';

interface Props {
  filters: FilterChoice;
  isSidebar?: boolean;
}

export const NationwideSuburbLinks = ({ filters, isSidebar = false }: Props) => (
  <SuburbLinks
    filters={filters}
    locations={safeKeysOf(STATE_PER_METRO).map(metro => ({ metro }))}
    isSidebar={isSidebar}
  />
);
